const quickSettingsTypes = {
	OPEN_QUICK_SETTINGS: 'OPEN_QUICK_SETTINGS',
	UPDATE_QUICK_SETTINGS: 'UPDATE_QUICK_SETTINGS',
	UPDATE_QUICK_SETTINGS_API: 'UPDATE_QUICK_SETTINGS_API',
};
export default quickSettingsTypes;
